module.exports = __webpack_public_path__ + "static/images/skill-checked.f57b19f.png";